import React, { useEffect, useState } from "react";
import {
  userBackend,
} from "../../services";
import { toast } from "sonner";
import { TextInput } from "../../modals/components";

interface ModalLoaderProps {
  user_id: number;
  onSave: () => void;
  closeModal: () => void;
}

const NewPasswordModal: React.FC<ModalLoaderProps> = ({
  user_id,
  onSave,
  closeModal,
}) => {
  const [password, setPassword] = useState<string>("");
  const [passwordToConfirm, setConfirmPassword] = useState<string>("");

  const saveAction = async () => {
    try {
      userBackend
        .updateUserPassword(password, user_id)
        .then((res) => {
          toast("Пароль изменен");
        })
        .catch((e) => {
          console.log(e);
          toast("Ошибка сохранения");
        });
    } catch (e) {
      console.log(e);
      toast("Ошибка сохранения");
    }
  };

  const closeWithSave = async () => {
    if (password.length < 8) {
      toast("Пароль должен быть не меньше 8 символов");
      return;
    }
    if (password !== passwordToConfirm) {
      toast("Пароли не совпадают");
      return;
    }
    await saveAction();
    onSave(); // Передаем новое фото в callback
    closeModal(); // Закрываем модальное окно
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Новый пароль</h3>
      </div>
      <form className="columnCenter">
        <TextInput
          label="Пароль"
          type="password"
          value={password}
          required
          onChange={(event) => setPassword(event.target.value)}
        />

        <TextInput
          label="Повторите пароль"
          type="password"
          value={passwordToConfirm}
          onChange={(event) => setConfirmPassword(event.target.value)}
          required
        />
        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton"
            type="button"
            onClick={closeWithSave}
          >
            Сохранить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewPasswordModal;
